import React, { useContext, useEffect, useState } from 'react';
import * as API from '@/services/api/company.service';
import API_STATES from '@/constants/StateConstants';
import generalStyles from '@/components/General/Styles.module.scss';

import PropTypes from 'prop-types';
import { companyPageContext } from '@/components/NewCompanyPage/NewCompanyPage';

function parseMetadata(meta) {
  if (!meta) return {};
  if (typeof meta === 'string') {
    try {
      return JSON.parse(meta);
    } catch {
      return { raw: meta };
    }
  }
  return meta;
}

function BonusRunCreditsEntry(props) {
  const { nsCompanyId } = useContext(companyPageContext);
  const { runCredit, isEditable = false } = props;

  const initialCredits = Number.isFinite(+runCredit.creditCount) ? +runCredit.creditCount : 0;
  const [count, setCount] = useState(initialCredits);
  const [lastSavedCount, setLastSavedCount] = useState(initialCredits);
  const [saveCreditApiError, setSaveCreditApiError] = useState('');
  const [savedCreditApiState, setSavedCreditApiState] = useState(API_STATES.none);

  useEffect(() => {
    const val = Number.isFinite(+runCredit.creditCount) ? +runCredit.creditCount : 0;
    setCount(val);
    setLastSavedCount(val);
  }, [runCredit.creditCount]);

  function changeCredit(e) {
    const newCount = e.target.value;
    setCount(newCount);
  }

  async function saveCredit(id) {
    setSavedCreditApiState(API_STATES.loading);
    setSaveCreditApiError('');

    try {
      const { status } = await API.updateUserRunCreditCount(nsCompanyId,id, count);

      if (status === API_STATES.success) {
        setLastSavedCount(count);
        setSavedCreditApiState(API_STATES.success);
      } else {
        setCount(lastSavedCount);
        setSaveCreditApiError('Failed to save');
        setSavedCreditApiState(API_STATES.error);
      }
    } catch (err) {
      setCount(lastSavedCount);
      setSaveCreditApiError('Failed to save');
      setSavedCreditApiState(API_STATES.error);
    } finally {
      setTimeout(() => setSavedCreditApiState(API_STATES.none), 2000);
    }
  }



  return (
    <tr className={!runCredit.active ? generalStyles.disabledRow : undefined}>
      <td>
        <div style={{ fontWeight: 600 }}>{runCredit.user?.name || 'Unknown User'}</div>
        <div style={{ fontSize: 12, color: '#666' }}>{runCredit.user?.email || ''}</div>
      </td>

      <td className={generalStyles.cap}>Bonus Report</td>

      <td className={generalStyles.numeric}>{1}</td>

      <td>
        <input
          className={generalStyles.numeric}
          type="number"
          min={0}
          value={count}
          onChange={changeCredit}
          disabled={!isEditable}
        />
      </td>

      <td className={generalStyles.numeric}>{props.runCredit.usageCount}</td>

      <td className={generalStyles.numeric}>{props.runCredit.remainingCount}</td>

      {isEditable && (
        <td className="borderless">
          <button
            className={generalStyles.submitButton}
            disabled={count === lastSavedCount}
            onClick={() => saveCredit(runCredit.creditId)}
          >
            Save
          </button>

          {savedCreditApiState === API_STATES.loading ? (
            <span className={generalStyles.statusMessage}>Saving...</span>
          ) : savedCreditApiState === API_STATES.error ? (
            <span className={generalStyles.errorMessage}>{saveCreditApiError}</span>
          ) : (
            savedCreditApiState === API_STATES.success && (
              <span className={generalStyles.successMessage}>Saved!</span>
            )
          )}
        </td>
      )}
    </tr>
  );
}

BonusRunCreditsEntry.propTypes = {
  runCredit: PropTypes.shape({
    creditId: PropTypes.number.isRequired,
    authorizedUserId: PropTypes.number,
    sku: PropTypes.string,
    user: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      email: PropTypes.string,
    }).isRequired,
    baseCount: PropTypes.number,
    creditCount: PropTypes.number,
    usageCount: PropTypes.number,
    remainingCount: PropTypes.number,
    active: PropTypes.bool,
    metadata: PropTypes.any
  }).isRequired,
  isEditable: PropTypes.bool
};

export default BonusRunCreditsEntry;
